import React from 'react';
import DateAndTime from 'date-and-time';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import oIconLibrary from 'utils/iconLibrary';
import fnFormatLocationForGoogleCalendar from './fnFormatLocationForGoogleCalendar';

/**
 * Creates a link that generates a Google calendar event.
 * See https://stackoverflow.com/a/19867654
 *
 * @param {object} oEvent - Event details.
 * @returns {string}
 */
const fnBuildGoogleCalendarLink = (oEvent) => {
  const { TITLE, START_DATE_TIME, END_DATE_TIME, DESCRIPTION, LOCATION } =
    oEvent;
  const sTitle = encodeURIComponent(TITLE);

  const oStartDate = DateAndTime.parse(START_DATE_TIME, 'YYYY-MM-DDTHH:mm:ss');
  const sStartDate = DateAndTime.format(oStartDate, 'YYYYMMDDTHHmmss');
  const oEndDate = DateAndTime.parse(END_DATE_TIME, 'YYYY-MM-DDTHH:mm:ss');
  const sEndDate = DateAndTime.format(oEndDate, 'YYYYMMDDTHHmmss');
  const sDateTimes = `${sStartDate}/${sEndDate}`;

  const sDescription = encodeURIComponent(DESCRIPTION);

  let sLocation = fnFormatLocationForGoogleCalendar(LOCATION);
  sLocation = encodeURIComponent(sLocation);

  const sGoogleLink = `http://www.google.com/calendar/event?action=TEMPLATE&text=${sTitle}&dates=${sDateTimes}&details=${sDescription}&location=${sLocation}`;
  return sGoogleLink;
};

const AddToCalendar = ({ oEvent }) => {
  const sGoogleLink = fnBuildGoogleCalendarLink(oEvent);
  return (
    <a
      target='_blank'
      href={sGoogleLink}
      className='eventDetails___addToCal button button--withIcon'
      rel='noreferrer'
    >
      <span className='button--iconOnly--secondary'>
        <FontAwesomeIcon icon={oIconLibrary.fontAwesome.addToCalendar} />
      </span>
      Add to Calendar
    </a>
  );
};

AddToCalendar.propTypes = {
  oEvent: PropTypes.shape({
    TITLE: PropTypes.string,
    START_DATE_TIME: PropTypes.string,
    END_DATE_TIME: PropTypes.string,
    DESCRIPTION: PropTypes.string,
    LOCATION: PropTypes.shape({
      NAME: PropTypes.string,
      ROOM: PropTypes.string,
      ADDRESSBLOCK: PropTypes.string,
      CITY: PropTypes.string,
      STATE: PropTypes.string,
      POSTCODE: PropTypes.string,
    }),
  }).isRequired,
};

export default AddToCalendar;
